export default __webpack_public_path__ + "static/media/dash-outgoing.483fe760.svg";